import aichatBR from './aichat.br';
import aichatCL from './aichat.cl';
import aichatCO from './aichat.co';
import aichatMX from './aichat.mx';

const locales = {
  BR: aichatBR,
  CL: aichatCL,
  CO: aichatCO,
  MX: aichatMX,
};

export default locales;
